module.exports = ".main-header {\n  margin: 0 0 10px;\n  padding: 0 0 10px;\n  background: #2A0934;\n  -webkit-box-shadow: 0px 1px 5px #4424D6;\n          box-shadow: 0px 1px 5px #4424D6; }\n  .main-header .title {\n    color: #D4DDF7;\n    padding: 4px 10px;\n    margin: 0 2px;\n    font-size: large;\n    font-size: 2rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main